export default "__VITE_ASSET__j07OHtjv__"